// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<polygon points="21,20 21,21 3,21 3,3 4,3 4,20" />
	<polygon points="10.5,9.2 13,11.7 19,5.7 19,9.5 20,9.5 20,4 14.5,4 14.5,5 18.3,5 13,10.3 10.5,7.8 6.2,12.1 6.8,12.9" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-chart-line-4YM-ohES.js.map
